"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../baseSchema");
const baseTrySchema_1 = require("../baseSchema/baseTrySchema");
class TryDownloadSubtitlesSchema extends baseTrySchema_1.BaseTrySchema {
    constructor({ result, statusCode, failureDescription }) {
        super({
            result,
            statusCode,
            failureDescription,
            componentName: 'DOWNLOAD_SUBTITLES_BUTTON',
            componentSource: 'DOWNLOAD_SUBTITLES_BUTTON'
        });
        this.action = baseSchema_1.ActionsName.TRY_DOWNLOAD_SUBTITLES;
    }
    getDataHubEventData() {
        return {
            ...super.prepare()
        };
    }
}
exports.default = TryDownloadSubtitlesSchema;
